import React, { useState, useEffect, useRef } from "react";
import queryString from 'query-string';
import { Form, Progress, Alert, Input } from 'reactstrap';
import { CSSTransition } from 'react-transition-group';

import { useLocalization } from "../../containers/I18nProvider";

import { WithCaptcha } from '../../containers/captcha';
import logo from './img/logo.jpeg';

const LoginForm = ({ api, location, ...props }) => {
  const nodeRef = useRef(null);
  const { translate } = useLocalization();
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'hdfibra';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = "Houve um erro. Tente novamente";

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }
  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="login-hdfibra-container text-align-center" ref={nodeRef}>
        <div className="login-hdfibra-body">
          <div className="login-hdfibra-header">
            <img src={logo} alt="logo" className="logo-hdfibra rounded mx-auto d-block" />
          </div>
          <Form onSubmit={event => onSubmit(event)}>
            <div className="hdfibra-input-container">
              <Input
                className="hdfibra-input"
                disabled={onLogin}
                required={true}
                tabIndex={1}
                type="text"
                autoCorrect="off"
                autoCapitalize="none"
                id="user"
                placeholder="Digite seu usuário abaixo"
                onChange={e => setUsername(e.target.value)}
              />
            </div>
            <div className="hdfibra-input-container">
              <Input
                className="hdfibra-input"
                bsClass=""
                required={true}
                disabled={onLogin}
                tabIndex={1}
                type="password"
                autoCorrect="off"
                autoCapitalize="none"
                id="password"
                placeholder="Digite sua senha abaixo"
                onChange={e => setPassword(e.target.value)}
              />
            </div>
            {!onLogin ?
              <div className="row hdfibra-btns-row">
                <div className="col-xs-12 col-md-12 col-lg-12">
                  <div>
                    <button
                      block={!parameters.failureRedirect}
                      tabIndex={1}
                      className="enter-hdfibra"
                      type="submit"
                      name="submit"
                      disabled={!props.turnstileSuccess}
                    >
                      {translate("ButtonEnter")}
                    </button>
                  </div>
                </div>
              </div>
              :
              <Progress animated color="danger" value={100} />
            }
            <div className="messages-container">
              <Alert color="danger" id="error-message" isOpen={error.open} toggle={() => setError({ open: false })}>
                {error.message}
              </Alert>
            </div>
          </Form>
        </div>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { style: { marginTop: '2rem' } });
